import { render, staticRenderFns } from "./StylistPerformanceOverview.vue?vue&type=template&id=0ef5a52e&scoped=true"
import script from "./StylistPerformanceOverview.vue?vue&type=script&lang=js"
export * from "./StylistPerformanceOverview.vue?vue&type=script&lang=js"
import style0 from "./StylistPerformanceOverview.vue?vue&type=style&index=0&id=0ef5a52e&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ef5a52e",
  null
  
)

export default component.exports